export default __webpack_public_path__ + "static/media/avatar_71.02c53491.png";